export const config = (envConfig) =>  {
  return {
    oidc: {
      clientId: envConfig.oktaClientId,
      issuer: envConfig.oktaIssuer,
      redirectUri: envConfig.oktaRedirectUri,
      postLogoutRedirectUri: envConfig.oktaLogoutRedirectUri,
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
      testing: {
        disableHttpsCheck: envConfig.oktaTestingDisableHttpsCheck,
      },
      tokenManager: {
        secure: true,
        storage: 'localStorage',
        expireEarlySeconds: 120,

        // if token expire dont try to renew automatically
        autoRenew: false
      },
    },
}}
